import { SeedingFloatingActionBar } from '../common/SeedingFloatingActionBar';
import type { SeedingPrimaryCtaDual } from '../types';

interface ProposeAcceptRejectActionBarProps {
  cta: SeedingPrimaryCtaDual;
  onAccept: () => void;
  onReject: () => void;
  /** 수락 mutation pending — 수락 버튼 loading + 거절 버튼 비활성(상호 배타). 더블탭 방지. (SID-4740) */
  acceptLoading?: boolean;
  /**
   * 거절 mutation pending — 수락 버튼 비활성 + 거절 버튼 loading(스피너). 거절 시트를
   * 취소·외부클릭으로 닫아 액션바가 다시 보여도 거절 처리 상태를 그대로 반영한다. (SID-4740)
   */
  rejectPending?: boolean;
}

export const ProposeAcceptRejectActionBar = ({
  cta,
  onAccept,
  onReject,
  acceptLoading = false,
  rejectPending = false,
}: ProposeAcceptRejectActionBarProps) => (
  <SeedingFloatingActionBar
    mode="dual"
    variant={cta.variant ?? 'default'}
    primary={{
      label: cta.primary.label,
      disabled: (cta.primary.disabled ?? false) || rejectPending,
      loading: acceptLoading,
      onClick: onAccept,
    }}
    secondary={{
      label: cta.secondary.label,
      // 수락 pending 시엔 거절 비활성, 거절 pending 시엔 거절을 loading(스피너)으로. (SID-4740)
      disabled: (cta.secondary.disabled ?? false) || acceptLoading,
      loading: rejectPending,
      onClick: onReject,
    }}
  />
);
